import { ReactNode, useEffect, useState } from 'react'
import _ from 'lodash/fp'

interface IProps {
  handleSubmit: () => void,
  name?: string,
  children: ReactNode
}

let currentUUID: number | undefined

const eventsSet: Array<number> = []

const ValidateOnEnter = (props: IProps) => {
  const [uuid] = useState(Date.now())

  useEffect(() => addEventListener(props.handleSubmit, uuid))

  return (<>{props.children}</>)
}

const addEventListener = (handleSubmit: () => void, uuid: number) => {
  if (uuid && !_.contains(uuid)(eventsSet)) {
    document.addEventListener('keypress', handleKeyPressed(handleSubmit, uuid))
    eventsSet.push(uuid)
  }

  currentUUID = uuid

  return () => {
    if (currentUUID === uuid) {
      currentUUID = undefined
    }
  }
}

const handleKeyPressed = (handleSubmit: () => void, uuid: number) => (event: any) => {
  if (event.key === 'Enter' && uuid === currentUUID) {
    currentUUID = undefined

    handleSubmit()
  }
}

export default ValidateOnEnter
